import React from "react";
import { BodyText } from "../../styles/global";
import {
  LeftSection,
  Wrapper,
  RightSection,
  HeroTextWrapper,
  Captiontext,
  MobileButtonSection,
  EarlyAccessLink,
  HeaderImageWrapper,
  LeftBlurBackground,
  RightBlurBackground,
} from "./Header.style";
import "./header.css";
import { motion } from "framer-motion";

export const Header: React.FC = () => {
  return (
    <>
      <Wrapper>
        <LeftBlurBackground />
        <RightBlurBackground />
        <LeftSection>
          <Captiontext><br/>
            <div>The all Inclusive</div>
            <div>best financial super app</div>
            <div>for the children/parents</div>
            <div>gen z, millennials and elite aged.</div>
          </Captiontext>

          <HeroTextWrapper>
            <BodyText style={{ textAlign: "left" }}>
              Hexa virtual accounts, Virtual debit card, scholarship for kids,
              Cash reward for parents, Annual travels and tours for lucky
              families, Earn 5% -15% on the Saving plans, Earn over 10% - 40%
              returns on Investment.
            </BodyText>
          </HeroTextWrapper>

          <MobileButtonSection>
            <div>
              <img src="img/Google play button.svg" alt="" />
            </div>
            <div>
              <img src="img/App store button.svg" alt="" />
            </div>
          </MobileButtonSection>
          <EarlyAccessLink to="/">
            <span>Get Early Access</span>
          </EarlyAccessLink>
        </LeftSection>
        <RightSection>
          <HeaderImageWrapper>
            <motion.div
              whileInView={{ x: 0, opacity: 1 }}
              initial={{ x: 50, opacity: 0 }}
              transition={{ duration: 2, stiffness: 100 }}
            >
              <img src="img/Hero section mockup with card.png" alt="" />
            </motion.div>
          </HeaderImageWrapper>
        </RightSection>
      </Wrapper>
    </>
  );
};
